// 商户端-商品审核状态
export enum CheckStatus {
    '未提交',
    '审核中',
    '审核通过',
    '驳回'
}
// 运营端-商品审核状态
export enum OCheckStatus {
    '待审核'    = 1,
    '审核通过',
    '驳回'
}
// 商品详情页来源位置
export enum ProductO {
    '已上线' = 1,
    '新增',
    '审核列表',
    '待上线'
}
//商品状态
export enum ProductStatus {
    '上架',
    '下架',
}
// 商品标签
export enum ProductType {
    '空' ,
    '正常',
    '溢价',
    '无同款不比价',
}
//特殊商品
export enum SpecialProduct {
    '每日',
    '每周',
    '每月',
    '每年',
    '每ID'
}

